import {
    Calendar as PrimeCalendar,
    CalendarProps as PrimeCalendarProps,
} from 'primereact/calendar';

export const Calendar = ({ ...rest }: PrimeCalendarProps) => {
    return <PrimeCalendar dateFormat="dd-mm-yy" {...rest} />;
};
